import API from 'services/api';

import { ICalculationDocument } from '../models';

export const getCalculationDocuments = (id: string): Promise<ICalculationDocument> =>
  API.get(`/api/accommodation/calculations/${id}/documents`).then(response => response?.data);
